import { Empty, Input, Select, Spin } from "antd";
import { inicialNome } from "./chatFormat";

export const ChatNovaConversa = ({
  contatos,
  instituicoes,
  busca,
  instituicao,
  carregando,
  onBuscar,
  onInstituicao,
  onSelecionar,
}) => {
  const opcoesInstituicao = (instituicoes || []).map((item) => ({
    value: item.codigo,
    label: item.nome,
  }));

  return (
    <>
      <div className="chat-busca">
        <Select
          allowClear
          showSearch
          placeholder="Filtrar por instituição"
          value={instituicao}
          options={opcoesInstituicao}
          optionFilterProp="label"
          onChange={onInstituicao}
        />
        <Input.Search
          allowClear
          placeholder="Buscar contato"
          value={busca}
          onChange={(evento) => onBuscar(evento.target.value)}
        />
      </div>
      <div className="chat-lista">
        {carregando ? (
          <div className="chat-vazio">
            <Spin />
          </div>
        ) : !contatos?.length ? (
          <div className="chat-vazio">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhum contato disponível"
            />
          </div>
        ) : (
          contatos.map((contato) => (
            <button
              type="button"
              key={contato.codigo}
              className="chat-item"
              onClick={() => onSelecionar(contato)}
            >
              <span className="chat-avatar chat-avatar--lista">
                {inicialNome(contato.nome)}
              </span>
              <span className="chat-item__texto">
                <span className="chat-item__topo">
                  <strong>{contato.nome}</strong>
                </span>
                <span className="chat-item__preview">
                  <span>{contato.master ? "Chat master" : "Chat padrão"}</span>
                </span>
              </span>
            </button>
          ))
        )}
      </div>
    </>
  );
};
